// LocalStorageService.js
import FuncionesAyuda from "./FuncionesAyuda";
import Vue from "vue";

const LocalStorageService = (function () {
    let _service;

    function _getService() {
        if (!_service) {
            _service = this;
            return _service
        }
        return _service
    }

    function _getAccessToken() {
        const sesionK = sessionStorage.getItem("vue-session-key");
        if (sesionK !== undefined && sesionK !== null) {
            return JSON.parse(sesionK).token;
        }
        return null;
    }
    function _getRefreshAccessToken() {
        const sesionK = sessionStorage.getItem("vue-session-key");
        if (sesionK !== undefined && sesionK !== null) {
            return JSON.parse(sesionK).refresh;
        }
        return null;
    }

    function getUserDetail() {
        const dataUserDetail = sessionStorage.getItem("dtuu");
        if (dataUserDetail !== undefined && dataUserDetail !== null) {
            return JSON.parse(Vue.prototype.$desencriptarFull(dataUserDetail));
        }
        return null;
    }

    function getUserDetailSecurity() {
        const dataUserDetail = sessionStorage.getItem("dtup");
        if (dataUserDetail !== undefined && dataUserDetail !== null) {
            return JSON.parse(Vue.prototype.$desencriptarFull(dataUserDetail));
        }
        return null;
    }

    function getUserDetailClinics() {
        const dataUserDetail = sessionStorage.getItem("dtuc");
        if (dataUserDetail !== undefined && dataUserDetail !== null) {
            return JSON.parse(Vue.prototype.$desencriptarFull(dataUserDetail));
        }
        return null;
    }

    function _getAuthorities() {
        return getUserDetailSecurity();
    }

    function _can(permiso) {
        const dataUserDetail = getUserDetailSecurity();
        if (dataUserDetail !== null) {
            return dataUserDetail.includes(permiso);
        } else {
            console.info("--usuario sin permisos--");
            return false;
        }
    }

    function _getIdUsuario() {
        const dataUserDetail = getUserDetail();
        if (dataUserDetail !== null) {
            return dataUserDetail.idUsuario;
        }
        return null;
    }

    function _getNombreCompletoUsuario() {
        const dataUserDetail = getUserDetail();
        if (dataUserDetail !== null) {
            return dataUserDetail.nombreCompleto;
        }
        return null;
    }

    function _getNombrUsuario() {
        const dataUserDetail = getUserDetail();
        if (dataUserDetail !== null) {
            return dataUserDetail.nombre;
        }
        return null;
    }
    function _getApellidoPaternoUsuario() {
        const dataUserDetail = getUserDetail();
        if (dataUserDetail !== null) {
            return dataUserDetail.apellidoPaterno;
        }
        return null;
    }
    function _getApellidoMaternoUsuario() {
        const dataUserDetail = getUserDetail();
        if (dataUserDetail !== null) {
            return dataUserDetail.apellidoMaterno;
        }
        return null;
    }
    /**
     * Funciones dinámicas para la obtención de datos en base a la clinica
     * */

    /*Funcion para obtener todas las clinicas del usuario logueado*/
    function _getClinicas() {
        const dataUserDetailClinics = getUserDetailClinics();
        if (dataUserDetailClinics !== null) {
            return dataUserDetailClinics;
        }
        return null;
    }

    /*Funcion para establecer la clinica activa desde el login y/o el menu*/
    function _setClinicaActual(idClinica) {

        if (idClinica === undefined || idClinica === null) {
            const clinicas = _getClinicas();
            console.info(clinicas);
            sessionStorage.setItem("clinica_actual", clinicas[0].idClinica);
        } else {
            sessionStorage.setItem("clinica_actual", idClinica);
        }

    }

    /*Funcion para establecer la clinica activa desde el login y/o el menu*/
    function _setClinicaActualHorasDiferencia(diferenciaHoras) {
        sessionStorage.setItem("clinica_diferencia_horas", diferenciaHoras);

    }

    function _getClinicaActualHorasDiferencia() {
        return parseInt(sessionStorage.getItem("clinica_diferencia_horas"));
    }

    function _setMenus(menus) {
        sessionStorage.setItem("menus", JSON.stringify(menus));
    }

    function _existMenus() {
        return !!_getMenus();
    }

    function _getMenus() {
        return JSON.parse(sessionStorage.getItem("menus"));
    }
    function _removeMenus() {
        return sessionStorage.removeItem("menus");
    }


    function _setPostales(postales) {
        sessionStorage.setItem("postales", JSON.stringify(postales));
    }

    function _existPostales() {
        return !!sessionStorage.getItem("postales");
    }

    function _getPostales() {
        return JSON.parse(sessionStorage.getItem("postales"));
    }
    function _removePostales() {
        return sessionStorage.removeItem("postales");
    }


    /*Funcion para obtener el arreglo completo de la clinica activa*/
    function _getClinicaActual() {
        const idClinicaActual = sessionStorage.getItem("clinica_actual");
        const clinicas = _getClinicas();
        return clinicas.find(c => c.idClinica == idClinicaActual);
    }

    function _getIdEmpleado() {
        const tokenValor = _getClinicaActual();
        return tokenValor.idEmpleado;
    }

    function _getIdClinica() {
        const tokenValor = _getClinicaActual();
        return tokenValor.idClinica;
    }

    function _getIdCompania() {
        const tokenValor = _getClinicaActual();
        return tokenValor.idCompania;
    }

    function _getNombreClinica() {
        const tokenValor = _getClinicaActual();
        return tokenValor.nombreClinica;
    }

    function _getDebug() {
        return sessionStorage.getItem("debug");
    }

    function _getTokenAWS() {
        if(sessionStorage.getItem("jdhfjsf7482hye9") !== null){
            return FuncionesAyuda.desencriptar(sessionStorage.getItem("jdhfjsf7482hye9"));
        }else{
            return null;
        }
    }

    function _setTokenAWS(item) {
        return sessionStorage.setItem("jdhfjsf7482hye9", FuncionesAyuda.encriptar(item));
    }

    function _getTokenAWSPti() {
        if(sessionStorage.getItem("oiue3478hbcd") !== null){
            return FuncionesAyuda.desencriptar(sessionStorage.getItem("oiue3478hbcd"));
        }else{
            return null;
        }
    }

    function _setTokenAWSPti(item) {
        return sessionStorage.setItem("oiue3478hbcd", FuncionesAyuda.encriptar(item));
    }

    function _getTokenAWSGenerico() {
        if(sessionStorage.getItem("tk-gaws") !== null){
            return FuncionesAyuda.desencriptar(sessionStorage.getItem("tk-gaws"));
        }else{
            return null;
        }
    }

    function _setTokenAWSGenerico(item) {
        return sessionStorage.setItem("tk-gaws", FuncionesAyuda.encriptar(item));
    }

    function _setActiveTabPacientePerfil(item){
        return sessionStorage.setItem("activeTabIndex", item);
    }

    function _setActiveSubTabPacientePerfil(item){
        return sessionStorage.setItem("subTabIndex", item);
    }

    function _getActiveTabPacientePerfil() {
        if(sessionStorage.getItem("activeTabIndex") !== null){
            return sessionStorage.getItem("activeTabIndex");
        }else{
            return null;
        }
    }

    function _getActiveSubTabPacientePerfil() {
        if(sessionStorage.getItem("subTabIndex") !== null){
            return sessionStorage.getItem("subTabIndex");
        }else{
            return null;
        }
    }

    function _removeActiveTabPacientePerfil() {
        return sessionStorage.removeItem("activeTabIndex");
    }

    function _removeActiveSubTabPacientePerfil() {
        return sessionStorage.removeItem("subTabIndex");
    }

    function _getFiltros() {
        return JSON.parse(localStorage.filtros)
    }

    function _getFiltrosPerfil() {
        return JSON.parse(localStorage.filtrosPerfil)
    }

    function _getTabIndexActivo() {
        return JSON.parse(localStorage.tabIndexActivo)
    }


    /*Fin funciones dinámicas*/

    return {
        getService: _getService,
        getAccessToken: _getAccessToken,
        getRefreshAccessToken:_getRefreshAccessToken,
        getClinicas: _getClinicas,
        setClinicaActual: _setClinicaActual,
        setClinicaActualHorasDiferencia: _setClinicaActualHorasDiferencia,
        getClinicaActualHorasDiferencia: _getClinicaActualHorasDiferencia,
        getIdEmpleado: _getIdEmpleado,
        getIdClinica: _getIdClinica,
        getIdCompania: _getIdCompania,
        getAuthorities: _getAuthorities,
        getIdUsuario: _getIdUsuario,
        getNombreClinica: _getNombreClinica,
        getNombreCompletoUsuario: _getNombreCompletoUsuario,
        getNombreUsuario: _getNombrUsuario,
        getApellidoPaternoUsuario: _getApellidoPaternoUsuario,
        getApellidoMaternoUsuario: _getApellidoMaternoUsuario,
        can: _can,
        setMenus: _setMenus,
        existMenus: _existMenus,
        getMenus: _getMenus,
        setPostales: _setPostales,
        existPostales: _existPostales,
        getPostales: _getPostales,
        removeMenus:_removeMenus,
        removePostales:_removePostales,
        getDebug:_getDebug,
        getTokenAWS:_getTokenAWS,
        setTokenAWS:_setTokenAWS,
        getTokenAWSPti:_getTokenAWSPti,
        setTokenAWSPti:_setTokenAWSPti,
        getTokenAWSGenerico: _getTokenAWSGenerico,
        setTokenAWSGenerico: _setTokenAWSGenerico,
        setActiveTabPacientePerfil: _setActiveTabPacientePerfil,
        setActiveSubTabPacientePerfil: _setActiveSubTabPacientePerfil,
        getActiveTabPacientePerfil: _getActiveTabPacientePerfil,
        getActiveSubTabPacientePerfil: _getActiveSubTabPacientePerfil,
        removeActiveTabPacientePerfil: _removeActiveTabPacientePerfil,
        removeActiveSubTabPacientePerfil: _removeActiveSubTabPacientePerfil,
        getFiltros: _getFiltros,
        getFiltrosPerfil: _getFiltrosPerfil,
        getTabIndexActivo: _getTabIndexActivo,

    }
})();
export default LocalStorageService;
